import { createContext, useContext } from 'react'

const InstructorViewContext = createContext(null)

export function useInstructorView() {
  return useContext(InstructorViewContext)
}

export default InstructorViewContext
